import { useRef, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import { Sire } from '@/rtk-query.gql';

import { EditSireForm, EditSireFormValues } from '../edit-sire-form';

type EditSireDialogProps = {
  visible: boolean;
  onHide: () => void;
  sire?: Sire;
  onSave?: (data: EditSireFormValues) => void;
  onError?: (error: unknown) => void;
};

export const EditSireDialog = ({
  visible,
  onHide,
  sire,
  onSave,
  onError,
}: EditSireDialogProps) => {
  const { t } = useTranslation();
  const dialogRef = useRef<Dialog>(null);
  const [dialogContainer, setDialogContainer] = useState<HTMLElement>();

  return (
    <Dialog
      ref={dialogRef}
      header={t('sire.editSire')}
      visible={visible}
      onHide={onHide}
      modal
      className="w-[1000px] max-w-[95vw]"
      onShow={() =>
        setDialogContainer(dialogRef.current?.getMask() ?? undefined)
      }
    >
      <EditSireForm
        onCancel={onHide}
        sire={sire}
        onSuccess={onSave}
        onError={onError}
        calendarContainer={dialogContainer}
      />
    </Dialog>
  );
};
